'use client';
// Botón de compra de /planes y /planesbeta. Mismo flujo que tenía PlanesClient:
//   - InitiateCheckout a Meta con el precio mensual en USD (los de Stripe).
//   - Si el banner LANZAMIENTO25 sigue vivo, el cupón viaja en la URL.
//   - Logueado → /suscripcion (paga o cambia de plan).
//   - Sin sesión → registro con el plan elegido; desde /planesbeta (o ?demo=true)
//     el registro lleva promo=demo1day: prueba de 3 días sin tarjeta.
import { trackEvent } from '@/components/analytics/LandingTracker';
import { trackFbq } from '@/components/analytics/MetaPixel';

// Precios mensuales en USD, iguales a TOKEN_PLANS (Stripe solo tiene el mensual).
const PRECIO = { basico: 24.99, profesional: 69, enterprise: 199 };
const COUNTDOWN_MS = 7 * 24 * 60 * 60 * 1000;

function promoLanzamiento() {
  try {
    const startMs = parseInt(window.localStorage.getItem('dr_victor_promo_countdown_start') || '0', 10);
    const dismissed = window.localStorage.getItem('dr_victor_promo_dismissed') === '1';
    if (startMs && !dismissed && (Date.now() - startMs) < COUNTDOWN_MS) return '&promo=LANZAMIENTO25';
  } catch { /* modo privado: el usuario aplica el cupón a mano */ }
  return '';
}

async function elegir(plan) {
  trackEvent('plan_select', { element: `plan-${plan}` });
  const checkoutPayload = { content_name: plan, content_category: 'plan' };
  if (typeof PRECIO[plan] === 'number') {
    checkoutPayload.value = PRECIO[plan];
    checkoutPayload.currency = 'USD';
  }
  trackFbq('track', 'InitiateCheckout', checkoutPayload);

  const promoQuery = promoLanzamiento();
  try {
    const me = await (await fetch('/api/auth/me', { cache: 'no-store' })).json();
    if (me?.id && !me?.error) {
      window.location.href = `/suscripcion?plan=${plan}${promoQuery}`;
      return;
    }
  } catch { /* sin sesión: sigue al registro */ }
  const { pathname, search } = window.location;
  const demo = pathname.includes('planesbeta') || new URLSearchParams(search).get('demo') === 'true';
  window.location.href = `/login?tab=register&plan=${plan}${demo ? '&promo=demo1day' : promoQuery}`;
}

export default function BotonPlan({ plan, className, style, children }) {
  return (
    <button type="button" className={className} style={style} data-track={`planes-elegir-${plan}`} onClick={() => elegir(plan)}>
      {children}
    </button>
  );
}
